import React, { useContext } from 'react';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image';

import { capitalizeFirstLetter } from '../../../Helpers/String';
import DonutChart from './DonutChart';
import Message from '../Message';
import ResultContext from '../../../Context/ResultContext';
import { Result } from '../../../Interface/Response/Validator/Result';
import Specifications from './Specifications/Specifications';

import useGetAcceptanceFeaturesMessages from '../../../Hook/Validator/UseGetAcceptanceFeaturesMessages';
import useGetPieChartData from '../../../Hook/Validator/UseGetPieChartData';
import useGetPieChartTotals from '../../../Hook/Validator/UseGetPieChartTotals';

const MortgageProperties: React.FC = () => {
    const result = useContext<Result | null>(ResultContext);
    const messages = useGetAcceptanceFeaturesMessages();
    const pieChartData = useGetPieChartData();
    const pieChartTotals = useGetPieChartTotals();

    if (!result) {
        return null;
    }

    const message =
        'Tijdens de coronacrisis en de nasleep hiervan, kunnen geldverstrekkers een tijdelijk afwijkend ' +
        'acceptatiebeleid voeren. Twijfelt u of dit het geval is, neem contact op met de geldverstrekker.';

    return (
        <Container fluid className="block-container mortgage-properties">
            <Message>
                <p>{message}</p>
            </Message>
            <Row>
                <h2 className="mortgage-properties__heading">
                    <Image
                        src={result.companyLogo}
                        alt={result.companyName}
                        className="mortgage-properties__heading__company-logo"
                    />
                    <span className="mortgage-properties__heading__label">{result.labelName}</span>
                </h2>
            </Row>
            <Row className="mortgage-properties__info">
                <Col>
                    <Specifications />
                </Col>
                <Col>
                    <DonutChart
                        title="Acceptatie kenmerken"
                        data={pieChartData?.acceptanceFeatures}
                        totals={pieChartTotals?.acceptanceFeatures}
                    />
                </Col>
            </Row>
            {messages && (
                <Row>
                    <Col>
                        <p className="text-sm-left mortgage-properties__judgement">
                            {capitalizeFirstLetter(messages.judgement)}
                        </p>
                    </Col>
                </Row>
            )}
        </Container>
    );
};

export default MortgageProperties;
